export default __webpack_public_path__ + "static/media/cj_logo_green.3260a666.svg";